<div class="list-doctors-wrapper" [dir]="language == 'fr' ? 'ltr' : 'rtl'">
  <div class="row" *ngFor="let doctor of doctors">
    <div class="col-md-10 col-sm-6 col-lg-10 mb-sm-12 mb-12" style="margin-bottom: 8px;">
      <div class="attribute-user d-flex flex-column h-100 favorite">
        <div class="row list">
          <!-- Left Column: Doctor Info -->
          <div class="col-lg-4">
            <div class="contact-user">
              <div class="avatar-sm">
                <!-- Fixed: Use doctor.photo instead of doctor?.owner -->
                <img class="avatar-img rounded-circle avatar avatar-sm" 
                     [src]="doctor | avatarSrc" 
                     [alt]="language == 'fr' ? doctor.getFullNameLatin() : doctor.getFullArabicName()" />
              </div>
              <div class="user">
                <div class="name-user"> 
                  <!-- Added safe navigation and fallback -->
                  {{ language == 'fr' ? (doctor?.getFullNameLatin() || '') : (doctor?.getFullArabicName() || '') }}
                </div>
                <div class="specialtiy-name">
                  <!-- Added safe navigation -->
                  {{ language == 'fr' ? (doctor?.specialityName || '') : (doctor?.specialityArabicName || '') }}
                </div>
              </div>
            </div>
          </div>

          <!-- Middle Column: Contact Info -->
          <div class="col-lg-5">
            <div class="contact">
              <!-- Address -->
              <div class="contact-patient">
                {{ language == 'fr' ? 'Adresse : ' : 'العنوان : ' }}
                <span>{{ language == 'fr' ? (doctor?.address || 'N/A') : (doctor?.arabicAddress || 'غير متوفر') }}</span>
              </div>
              
              <!-- Phone Numbers - Fixed display -->
              <div class="contact-patient">
                {{ language == 'fr' ? 'Téléphone fixe : ' : 'الهاتف الثابت : ' }}
                <span>{{ doctor?.fixPhone || (language == 'fr' ? 'N/A' : 'غير متوفر') }}</span>
              </div>
              
              <div class="contact-patient">
                {{ language == 'fr' ? 'Téléphone(s) mobile(s) : ' : 'الهاتف(ات) المحمول(ة) : ' }}
                <div class="mobile-numbers">
                  <!-- Fixed: Separate phone numbers properly -->
                  <span *ngIf="doctor?.mobilePhone">{{ doctor.mobilePhone }}</span>
                  <br *ngIf="doctor?.mobilePhone && doctor?.mobilePhone2">
                  <span *ngIf="doctor?.mobilePhone2">{{ doctor.mobilePhone2 }}</span>
                  <span *ngIf="!doctor?.mobilePhone && !doctor?.mobilePhone2">
                    {{ language == 'fr' ? 'N/A' : 'غير متوفر' }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Column: Actions -->
          <div class="col-lg-3">
            <a class="btn button-rdv small btn-navbar" 
               [routerLink]="['/booking', doctor?.id]" 
               [queryParams]="{ dir: language }">
              {{ language == 'fr' ? 'Prendre rendez-vous' : 'إحجز موعد' }}
            </a>
            <a class="btn small btm" 
               [href]="getProfileLink(doctor)" 
               target="_blank">
              {{ language == 'fr' ? 'Voir profil' : 'عرض الملف' }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-pagination [pageRequest]="pageRequest" (content)="doctors = $event" 
                class="paginate" [language]="language"></app-pagination>